import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { resolveUser } from "@/lib/session";
import { rememberPostAuthRedirect } from "@/lib/postAuthRedirect";

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthed(!!session);
    });
    // Validate against the auth server (with a refresh attempt) rather than
    // trusting a possibly-expired token in localStorage. Otherwise the route
    // renders while every authenticated action fails.
    resolveUser().then((user) => {
      if (!cancelled) setAuthed(!!user);
    });
    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);


  if (authed === null) return null;
  if (!authed) {
    rememberPostAuthRedirect(window.location.pathname + window.location.search);
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
